<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">Marching, Fighting, Dying</span></h1>
<p class="subtitle"><span class="bold">Experiences of Soldiers in the Peninsular War</span></p>
<p class="author"><span class="bold">Gareth Glover</span></p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?08c0dd2c